import React, { useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import {
	useAddRoleMutation,
	useEditRoleMutation,
	useGetSpecificRolesQuery,
} from "../../../../Redux/service/Roles&Permissions/RolesPermissions";
import Loader from "../../../Helpers/Loader/Loader";
import RolesInfo from "./RolesInfo";
import RolesSettings from "./RolesSettings";
import trans, { isRTL } from "../../../../utils";
import OffcanvasFooter from "../../../Helpers/Offcanvasfooter/OffcanvasFooter";
import { popupcontext } from "../../../../context/Popupscontext";

export default function RolesBody() {
	const [submitAttempt, setSubmitAttempt] = useState(false);
	let { handleClose, isEditing, currentRoleId, setReloadData } =
		useContext(popupcontext);
	const { data: Editvalues, refetch } = useGetSpecificRolesQuery(
		currentRoleId,
		{
			skip: !currentRoleId,
		}
	);
	let [AddRole, { isLoading: AddLoading }] = useAddRoleMutation();
	let [EditRole, { isLoading: EditLoading }] = useEditRoleMutation();
	let initialValues = {
		name: null,
		description: null,
		permissions: [],
		userType: null,
		isActive: true,
		expiry: null,
	};
	let validSchema = Yup.object({
		name: Yup.string()
			.required(trans("Name is required"))
			.min(3, trans("Name must be at least 3 characters"))
			.max(20, trans("Name must be at most 20 characters"))
			.matches(
				/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z0-9\s]+$/,
				trans("Name cannot contain special characters")
			)
			.test(
				"not-empty-or-spaces",
				trans("Name cannot be just whitespace"),
				(value) => !!value && value.trim().length > 0
			),
		permissions: Yup.array()
			.min(1, trans("Permissions is required"))
			.required(trans("Permissions is required")),
		description: Yup.string()
			.max(1000, trans("Description must be at most 1000 characters"))
			.nullable(),
		userType: Yup.string().required(trans("User type is required")),
	});
	let addRole = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val) => {
			try {
				if (isEditing) {
					console.log("val", val);
					let newVal = { ...val };

					const keysToDelete = [
						"createdAt",
						"createdBy",
						"updatedAt",
						"updatedBy",
						"updatedById",
						"createdById",
					];

					keysToDelete.forEach((key) => {
						if (key in newVal) delete newVal[key];
					});

					await EditRole({
						val: newVal,
						id: currentRoleId,
					}).unwrap();
					toast.success(trans("Role Edited Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					setReloadData(true);
					refetch();
					handleClose("form");
				} else {
					await AddRole(val).unwrap();
					toast.success(trans("Role Added Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					setReloadData(true);
					handleClose("form");
				}
			} catch (error) {
				console.log("errr", error);
				toast.error(`${error?.data?.message}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});
	useEffect(() => {
		if (isEditing && Editvalues?.data) {
			const data = Editvalues.data;
			addRole.setFieldValue("name", data.name ?? null);
			addRole.setFieldValue("description", data.description ?? null);
			addRole.setFieldValue(
				"permissions",
				data?.rolePermissions?.map((i) => i?.permission?.id) ?? []
			);
			addRole.setFieldValue("userType", data.userType ?? null);
			addRole.setFieldValue("isActive", data.isActive ?? true);
			addRole.setFieldValue("expiry", data.expiry ?? null);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEditing, Editvalues]);

	const handleSubmit = (e) => {
		e.preventDefault();
		setSubmitAttempt(true);
		addRole.handleSubmit(e);
	};

	console.log("AddRole", addRole);
	if (AddLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	if (EditLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	return (
		<div>
			<form dir={!isRTL ? "ltr" : "rtl"} onSubmit={handleSubmit}>
				<RolesInfo addData={addRole} />
				<RolesSettings addData={addRole} />
				<OffcanvasFooter addData={addRole} submitAttempt={submitAttempt} />
			</form>
		</div>
	);
}
